export const getSizes = () => {
  return ["default", "sm", "md", "lg", "xl", "2xl"];
};
